import { callApiNew } from 'src/middleware/apiMiddleware';

const verifyCode = (otp: string) =>
  callApiNew<VerifyOtpResponse>({
    endpoint: '/rewards/verify-otp',
    method: 'POST',
    body: { otp },
  });

const apiUtil = {
  verifyCode,
};

export default apiUtil;
